<template>
    <div class="detail-setoran-content">
        <SOSlotBase :container-name="'detail-setoran-content'" :loading="!formReady">
            <template v-slot:title-bar>
                <div v-if="!fullSize">
                    <SOTitleBar :page-title="`Detail Setoran`" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-t-16 f-regular" v-if="formReady" :class="{ prelative: fullSize }">
                    <div :class="{ closeImg: !fullSize }">
                        <SOTitleBar v-if="fullSize" :type="'close'" :transparent="true" @back="closePreview" />
                        <div :id="`setoran-preview`"></div>
                    </div>
                    <div v-if="!fullSize">
                        <div class="f-12 p-x-20 m-d-16">
                            <p class="m-d-4" style="color: #24A148">Setoran dari Outlet</p>
                            <p class="m-d-8 f-18 f-bold">Settlement EDC dari Outlet {{ getNamaOutlet }}</p>
                            <p class="m-d-0 f-c-midgrey">Dibuat {{ dateCreate }} oleh {{ dibuatOleh }}</p>
                        </div>
                        <div
                            class="p-x-20 p-y-12 f-regular m-d-16"
                            :class="{ approve: isApprove, decline: isDecline }"
                            v-if="!needConfirm"
                        >
                            <p class="m-d-4" :class="{ approve: isApprove, decline: isDecline }">
                                <span class="f-14 f-semi">
                                    Setoran {{ detailSettlementEdc.status_konfirmasi_formated }}
                                </span>
                                <span class="f-12"> ({{ detailSettlementEdc.tanggal_konfirmasi }})</span>
                            </p>
                            <p class="m-d-0 f-13">
                                <span class="f-c-midgrey">Catatan:</span> {{ detailData.catatan_konfirmasi }}
                            </p>
                        </div>
                        <div class="data-settlement p-x-20 f-16 f-regular m-d-16">
                            <p class="m-d-8 d-flex-between-center">
                                <span class="f-c-midgrey">Dari akun</span><span>{{ akunKeuangan.nama_akun }}</span>
                            </p>
                            <p class="m-d-8 d-flex-between-center">
                                <span class="f-c-midgrey">Ke akun</span>
                                <span>{{ detailData.nama_akun_rekening }} - {{ detailData.nomor_rekening }}</span>
                            </p>
                            <p class="m-d-8 d-flex-between-center">
                                <span class="f-c-midgrey">ID settlement</span>
                                <span>{{ detailData.id }}</span>
                              </p>
                            <p class="m-d-8 d-flex-between-center">
                                <span class="f-c-midgrey">Nominal settlement</span>
                                <span>{{ detailData.nominal | currency }}</span>
                            </p>
                            <p class="m-d-0 d-flex-between-center">
                                <span class="f-c-midgrey">Waktu uang masuk di rekening</span>
                                <span>{{ $moment(detailData.waktu_transfer).format("D MMM YYYY HH:mm") }}</span>
                            </p>
                            <p class="m-d-0 f-13 f-regular f-c-midgrey">
                                <span class="m-l-8">*waktu pencatatan akutansi</span> 
                            </p>
                        </div>
                        <div class="p-x-20 m-d-16" v-if="validateAccess('settlement.read')">
                            <div class="total-pembayaran" @click="gotoDetailPembayaran">
                                <p class="m-d-0 f-c-blue f-16 f-semi">
                                    Total {{ totalItemPembayaran }} Pembayaran
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M7.5 15L12.5 10L7.5 5"
                                            stroke="#206CFF"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </p>
                                <p class="m-d-0 f-13 f-regular f-c-midgrey">
                                    Settlement pada
                                    {{ $moment(detailData.waktu_settlement).format("D MMM YYYY HH:mm") }} (sesuai struk)
                                </p>
                            </div>
                        </div>
                        <div id="bukti-upload" class="images-container f-regular f-14 f-c-midgrey">
                            <div class="p-x-20 m-d-16">
                                <label class="m-d-8">Bukti Settlement</label>
                                <div class="img-wrapper" v-if="getImages.bukti.length > 0">
                                    <div
                                        class="img-container"
                                        v-for="(img, idx) in getImages.bukti"
                                        :key="`${idx}-nota`"
                                    >
                                        <img
                                            :id="`${idx}-nota`"
                                            width="80"
                                            height="90"
                                            :src="`${imgStore}${img.path}${img.name}`"
                                            @click="setFullSize('bukti', idx)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="p-x-20 m-d-16">
                                <label class="m-d-8">Mutasi Rekening</label>
                                <div class="img-wrapper" v-if="getImages.mutasi.length > 0">
                                    <div
                                        class="img-container"
                                        v-for="(img, idx) in getImages.mutasi"
                                        :key="`${idx}-nota`"
                                    >
                                        <img
                                            :id="`${idx}-nota`"
                                            width="80"
                                            height="90"
                                            :src="`${imgStore}${img.path}${img.name}`"
                                            @click="setFullSize('mutasi', idx)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <diV class="p-x-20 m-d-16 f-c-midgrey f-regular f-14">
                                <label class="m-d-8">Keterangan</label>
                                <p class="m-d-0 f-c-black">{{ getKeterangan }}</p>
                            </diV>
                            <!-- <div class="btn-wrape d-grid-12 align-items-center p-x-20" v-if="needConfirm"> -->
                            <div class="btn_action_wrapper d-grid-12 align-items-center p-x-20" v-if="detailData.status_konfirmasi === 0 && validateAccess('settlement.confirm')">
                                <div class="grid-cspan-6" style="padding-right: 8px">
                                    <SOButton
                                        :outline="true"
                                        :full="true"
                                        :text="'Tolak'"
                                        :id="`btn_act_tolak_settlement`"
                                        @action="gotoTolak"
                                    />
                                </div>
                                <div class="grid-cspan-6 p-l-8">
                                    <SOButton
                                        :primary="true"
                                        :full="true"
                                        :text="'Setujui'"
                                        :id="`btn_act_terima_settlement`"
                                        @action="gotoTerima"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";

import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../store/state";

export default {
  name: "SetoranDetail",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOLoadingPage,
    SOButton,
  },
  mounted() {
    if (this.detailData.status_konfirmasi === 0) {
      this.smartTrackingView("konfirmasi_settlement_mesin_edc");
    } else {
      this.smartTrackingView("detail_settlement_mesin_edc");
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (
        to.name != "mesin.edc.detail.setoran.tolak" ||
        to.name != "mesin.edc.detail_setoran_global.tolak"
      ) {
        vm.init();
      }

      if (to.name === "mesin.edc.detail_setoran_global") {
        vm.setIsGlobal(true);
      } else if (to.name === "mesin.edc.detail.setoran") {
        vm.setIsGlobal(false);
      }
    });
  },
  data() {
    return {
      formReady: false,
      isGlobal: false,
      fullSize: false,
      imgStore: "https://storage.googleapis.com/",
    };
  },
  watch: {
    response: function (newRes, oldRes) {
      if (newRes.success) {
        this.setFormReady(true);
      } else {
        this.$toast.error(newRes.err);
      }
    },
  },
  computed: {
    ...mapGetters(moduleName, {
      response: "response",
      detailSettlementEdc: "detailSettlementEdc",
    }),
    detailData() {
      return this.detailSettlementEdc.detail_data;
    },
    akunKeuangan() {
      return this.detailSettlementEdc.akun_keuangan_edc;
    },
    totalItemPembayaran() {
      return this.detailSettlementEdc.pembayaran_edc
        ? this.detailSettlementEdc.pembayaran_edc.length
        : 0;
    },
    isApprove() {
      return this.detailData.status_konfirmasi === 1;
    },
    isDecline() {
      return this.detailData.status_konfirmasi === 2;
    },
    isOwner() {
      return !this.detailData.karyawan ? true : false;
    },
    needConfirm() {
      return this.detailData.status_konfirmasi === 0;
    },
    getNamaOutlet() {
      return this.detailData.outlet.nama;
    },
    dateCreate() {
      return this.$moment(this.detailData.created_at).format(
        "D MMM YYYY HH:mm"
      );
    },
    getImages() {
      let images = {
        bukti: [],
        mutasi: [],
      };

      this.detailData.transaksi_foto.forEach((foto) => {
        let img = {
          path: `${foto.cloud_bucket}/`,
          name: foto.cloud_name,
        };
        if (foto.ref_table === "bukti_settlement_edc") {
          images.bukti.push(img);
        } else {
          images.mutasi.push(img);
        }
      });

      return images;
    },
    dibuatOleh() {
      return this.isOwner ? "Owner" : this.detailData.karyawan.nama;
    },
    getKeterangan() {
      return this.isOwner ? "Dibuat Oleh Owner" : this.detailData.keterangan;
    },
  },
  methods: {
    ...mapActions({
      getDetailSettlementEdc: `${moduleName}/getDetailSettlementEdc`,
    }),
    async init() {
      this.getDetailSettlementEdc(this.$route.params.id_settlement);
    },
    setFormReady(val) {
      this.formReady = val;
    },
    setIsGlobal(val) {
      this.isGlobal = val;
    },
    back() {
      this.$router.go(-1);
    },
    setFullSize(target, idx) {
      this.fullSize = true;

      let { getImages, imgStore } = this;
      let el = document.getElementById(`setoran-preview`);

      if (el.childNodes[0]) {
        el.removeChild(el.childNodes[0]);
      }

      setTimeout(() => {
        let img = new Image();
        img.src = `${imgStore}${getImages[target][idx].path}${getImages[target][idx].name}`;
        img.width = el.offsetWidth;
        img.onload = function () {
          el.appendChild(img);
        };

        window.scrollTo(0, 0);
      }, 100);
    },
    async closePreview() {
      this.fullSize = false;
      setTimeout(() => {
        document.getElementById("bukti-upload").scrollIntoView();
      }, 100);
    },
    gotoDetailPembayaran() {
      let pushto = this.isGlobal
        ? "mesin.edc.detail_setoran_global.pembayaran"
        : "mesin.edc.detail.setoran.pembayaran";
      this.$router.push({ name: pushto });
      this.smartTrackingClick("detail_pembayaran_settlement_mesin_edc");
    },
    gotoTolak() {
      let pushto = this.isGlobal
        ? "mesin.edc.detail_setoran_global.tolak"
        : "mesin.edc.detail.setoran.tolak";
      this.$router.push({ name: pushto });
      this.smartTrackingView("tolak_settlement_mesin_edc");
    },
    gotoTerima() {
      let pushto = this.isGlobal
        ? "mesin.edc.detail_setoran_global.approve"
        : "mesin.edc.detail.setoran.approve";
      this.$router.push({ name: pushto });
      this.smartTrackingView("setuju_settlement_mesin_edc");
    },
  },
};
</script>

<style scoped>
.detail-setoran-content div.approve {
  background: #e8fcee;
}

.detail-setoran-content div.decline {
  background: #fff1f1;
}

.detail-setoran-content p.approve {
  color: #40964c;
}

.detail-setoran-content .img-wrapper {
  background: #f6f6f6;
  display: flex;
  flex-wrap: wrap;
}
.detail-setoran-content p.decline {
  color: #964040;
}
.detail-setoran-content .total-pembayaran {
  padding: 10px 18px;
  border: 1px solid #c8d0dd;
  border-radius: 5px;
}
.detail-setoran-content .img-container {
  width: fit-content;
  margin: 0px 5px 8px;
}
.detail-setoran-content .img-container img {
  border: 1px solid #c8d0dd;
  border-radius: 5px;
}
.detail-setoran-content #setoran-preview {
  position: fixed;
  width: 100vw;
  top: 50%;
  transform: translateY(-50%);
}
.detail-setoran-content .closeImg #setoran-preview {
  display: none;
}
.detail-setoran-content .prelative {
  position: relative;
  background: black;
  height: 100vh;
  top: -52px;
  z-index: 30;
  display: flex;
  align-items: center;
}
</style>
